import React from "react";
import {Helmet} from "react-helmet";

function SEOTag({metaInformation}) {
    const title = `TonicHub - ${metaInformation?.meta_title}` || "TonicHub";
    const description = metaInformation?.meta_description || "";
    const ogImage = metaInformation?.og_image || "";

    return (
        <Helmet>
            <title>{title}</title>

            <meta name="title" content={title}/>

            <meta name="description" content={description}/>

            <meta property="og:title" content={title}/>

            <meta property="og:description" content={description}/>

            <meta property="og:image" content={ogImage}/>
        </Helmet>
    );
}

export default SEOTag;